var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn",
    transform: "translate(-843 -688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3151",
    "data-name": "Group 3151",
    transform: "translate(0 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(843 711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "linkedin-_161_",
    "data-name": "linkedin-[#161]",
    d: "M138,7333h-2.8v-4.9c0-1.344-.593-2.093-1.656-2.093-1.157,0-1.844.784-1.844,2.093v4.9h-2.8v-9.1h2.8v1.022a3.375,3.375,0,0,1,2.858-1.54c1.98,0,3.442,1.211,3.442,3.71V7333Zm-12.29-10.556a1.722,1.722,0,1,1,1.709-1.723,1.715,1.715,0,0,1-1.709,1.723ZM124,7333h3.5v-9.1H124Z",
    transform: "translate(-124 -7319)",
    fill: "#949494",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 14,
    height: 14,
    transform: "translate(843 711)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdin-icon.f9aab284be3d46b755e4bd236c5eace5.svg";
export { ForwardRef as ReactComponent };